import styled from 'styled-components';
import { colorBrandPrimary, colorGrey500, colorInfo } from 'constants/colors';
import { H5 } from '@goeuro/app/client/frontend-components/src/Typography';

export const OptionsWrapper = styled.div`
  min-width: 100%;
  height: 100%;
  min-height: 100%;
  padding: 0 16px;
  overflow-y: scroll;
`;

export const OptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0;
  border-bottom: 1px solid #f2f2f2;
  outline: 0;
`;

export const OptionLabelWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const OptionSelectedIcon = styled.div<{ selected?: boolean }>`
  width: 24px;
  height: 24px;
  margin: 0 8px 0 0;
  opacity: 0;
  color: ${colorInfo};
  transition: all 0.15s ease-in-out;

  ${({ selected }) => selected && 'opacity: 1;'}
`;

export const OptionLabel = styled.div<{ selected?: boolean; symbol?: boolean }>`
  color: ${colorBrandPrimary};

  ${({ selected }) => selected && 'font-weight: 700;'}

  ${({ symbol }) => symbol && 'margin: 0 8px 0 0;'}
`;

export const Header = styled.div`
  display: flex;
  padding: 0 16px;
  height: 60px;
  align-items: center;
  border-bottom: 1px solid ${colorGrey500};
`;

export const HeaderTitle = styled(H5)`
  flex: 1;
  text-align: center;
`;

export const IconButton = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background-color: transparent;
`;
